'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import { Text } from '../Text';
import { PriceContext } from './PriceContext';
import { styled } from 'styled-components';
const StyledSupportiveText = styled(Text).withConfig({
  componentId: "aui__sc-10zzsei-0"
})(["color:var(--aui-on-surface-soft);display:flex;flex-direction:row;align-items:center;gap:var(--aui-spacing-050);"]);
export const SupportiveText = props => {
  const {
    size
  } = useContext(PriceContext);
  const fontSizes = {
    sm: 0,
    md: 2,
    lg: 3
  };
  return /*#__PURE__*/React.createElement(StyledSupportiveText, _extends({
    size: fontSizes[size]
  }, props));
};